import { createSlice } from '@reduxjs/toolkit'
import {
  addStep,
  changeStep,
  removeStep,
  clearSteps,
  getSteps,
  setCurrentStep,
} from './calcv2Actions'

const initialState = {
  steps: [],
  loaded: false,
  saved: false,
  deleted: false,
  currentStep: 0,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const calcv2Slice = createSlice({
  name: 'calcv2',
  initialState,
  reducers: {
    clear: (state) => {
      state.loaded = false
      state.saved = false
      state.deleted = false
      state.currentStep = 0
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(addStep.pending, (state) => {
        state.saving = true
        state.saved = false
      })
      .addCase(addStep.fulfilled, (state) => {
        state.saving = false
        state.saved = true
      })
      .addCase(addStep.rejected, (state, { payload }) => {
        state.saving = false
        state.saved = false
      })
      .addCase(changeStep.pending, (state) => {
        state.saving = true
        state.saved = false
      })
      .addCase(changeStep.fulfilled, (state) => {
        state.saving = false
        state.saved = true
      })
      .addCase(changeStep.rejected, (state, { payload }) => {
        state.saving = false
        state.saved = false
      })
      .addCase(removeStep.pending, (state) => {
        state.deleting = true
        state.deleted = false
      })
      .addCase(removeStep.fulfilled, (state) => {
        state.deleting = false
        state.deleted = true
      })
      .addCase(removeStep.rejected, (state, { payload }) => {
        state.deleting = false
        state.deleted = console.log('Error deleting step:')
      })
      .addCase(getSteps.fulfilled, (state, { payload }) => {
        state.loaded = false
        state.steps = payload
      })
      .addCase(getSteps.pending, (state) => {
        state.loaded = false
      })
      .addCase(clearSteps.pending, (state) => {
        state.deleted = false
      })
      .addCase(clearSteps.fulfilled, (state) => {
        state.deleted = true
        state.loaded = false
      })
      .addCase(setCurrentStep.fulfilled, (state, { payload }) => {
        state.currentStep = payload
      })
  },
})

export const { clear } = calcv2Slice.actions
export default calcv2Slice.reducer
